// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.H9mKTsY97qIaCq9zjOK5 {
  height: auto;
  width: 100%;
  padding: 1.5rem;
  font-family: Noto Sans
}
.E6mPkLUfT3xmmhVTIumy {
  margin-bottom: 10px;
  display: inline-flex;
  align-items: center;
  gap: 0.375rem;
  font-family: Noto Sans;
  font-size: 17px !important;
  font-weight: 700;
  --tw-text-opacity: 1;
  color: rgb(47 47 47 / var(--tw-text-opacity, 1))
}
.rFndZGeCTYEDWa0FN_5h {
  height: auto;
  width: 100%;
  border-radius: 0.75rem;
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
  padding: 1.25rem
}
.q29yjqYNtbfcaxc2oquG {
  /* @apply ; */
}
`, "",{"version":3,"sources":["webpack://./src/pages/ViewPledgeTicket/ViewPledgeTicket.module.css"],"names":[],"mappings":"AACE;EAAA,YAAmC;EAAnC,WAAmC;EAAnC,eAAmC;EAAnC;AAAmC;AAGnC;EAAA,mBAAiG;EAAjG,oBAAiG;EAAjG,mBAAiG;EAAjG,aAAiG;EAAjG,sBAAiG;EAAjG,0BAAiG;EAAjG,gBAAiG;EAAjG,oBAAiG;EAAjG;AAAiG;AAGjG;EAAA,YAA4C;EAA5C,WAA4C;EAA5C,sBAA4C;EAA5C,kBAA4C;EAA5C,4DAA4C;EAA5C;AAA4C;AAE9C;EACE,aAAa;AACf","sourcesContent":[".mainContainer {\n  @apply w-full h-auto p-6 font-inter;\n}\n.title {\n  @apply font-bold text-gray-500 font-inter inline-flex items-center gap-1.5 !text-[17px] mb-[10px];\n}\n.bodySection {\n  @apply w-full h-auto p-5 bg-white rounded-xl;\n}\n.pdfViewer {\n  /* @apply ; */\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"mainContainer": `H9mKTsY97qIaCq9zjOK5`,
	"title": `E6mPkLUfT3xmmhVTIumy`,
	"bodySection": `rFndZGeCTYEDWa0FN_5h`,
	"pdfViewer": `q29yjqYNtbfcaxc2oquG`
};
export default ___CSS_LOADER_EXPORT___;
